const initialState = () => ({
  profiles: [],
  profile: {},
});

const state = initialState();

export default state;
